export default __webpack_public_path__ + "static/media/dottedImg.c0cd76f2.png";